// extracted by mini-css-extract-plugin
module.exports = {"homeBtn":"Slider_homeBtn__2pUYx","landingContainer":"Slider_landingContainer__3TCEP","slider":"Slider_slider__1XtH5"};